import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import Lineup from "../Lineup/Lineup";
import { DataContext } from "../../contexts/DataContext";
import { VizContext } from "../../contexts/VizContext";
import { APIContext } from "../../contexts/APIContext";
import TeamStats from "../TeamStats/TeamStats";
import LineupStream from "../Lineup/LineupStream";
import { GraphicsContext } from "../../contexts/GraphicsContext";
import Clock from "../RightSideBar/Clock";
import ClockStream from "../RightSideBar/ClockStream";
import { ClockContext } from "../../contexts/ClockContext";
import useLocalStorage from "../../Hooks/useLocalStorage";
import { UIContext } from "../../contexts/UIContext";
import { ControlContext } from "../../contexts/ControlContext";
import Select from "react-select";
import { Button } from "../../Theme/Hyper";
import SmartBarMain from "../SmartBarUI/SmartBarUI";

const Main = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const Title = styled.div`
  display: flex;
  border-bottom: 1px solid #dadde1;
  box-sizing: border-box;
  font-size: 1.5em;
  width: 100%;
  padding: 0.5em;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ActionPanel = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 1em;
  /* padding: 1em; */
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: #181d25;
  height: 100%;
`;
const GraphicsPanel = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 1em;
  padding: 1em;
  box-sizing: border-box;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: #181d25;
  height: 100%;
`;

const Lineups = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  height: 100%;
`;
const Row = styled.div`
  display: flex;
  align-items: center;
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const GraphicButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green ? "#0adb93" : props.red ? "#db0a41" : "#202731"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  height: 5%;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 1em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 60px;
  width: 120px;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;

const TitleButton = styled.div`
  display: flex;
  align-items: center;
  background-color: #20273196;
  height: 5%;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 1em;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 120px;
`;
const PeriodButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green ? "#0adb93" : props.red ? "#db0a41" : "#202731"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  height: 5%;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 1em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 60px;
  width: 80px;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;
const HiddenButton = styled.div`
  display: flex;
  align-items: center;
  opacity: 0;
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  height: 5%;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 1em;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 120px;
`;
const Input = styled.input`
  background-color: #1f222b;
  border-radius: 4px;
  border: none;
  padding: 1em;
  margin-bottom: 1em;
  outline: none;
  color: #fff;
  width: 400px;
`;

const Tabs = styled.div`
  display: flex;
`;

const Tab = styled.div`
  display: flex;
  padding: 10px;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  margin-right: 4px;
  background-color: ${(props) => (props.selected ? "#db0a41" : "#181d25")};
`;

const SelectContainer = styled(Select)`
  margin-bottom: 0.5em;
  width: 90%;
  ${(props) => props.minWidth && `min-width: ${props.minWidth}px;`}
`;

const DropdownStyles = {
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#0e1219",
  }),
  option: (provided, state) => {
    return {
      ...provided,
      backgroundColor: "#0e1219",
      "&:hover": {
        color: "#db0a41",
      },
    };
  },
  control: (provided) => ({
    ...provided,
    backgroundColor: "#0e1219",
    borderColor: "#384454",
  }),
  valueContainer: (provided) => ({
    ...provided,
    backgroundColor: "#0e1219",
    borderColor: "#384454",
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = "opacity 300ms";

    return { ...provided, opacity, transition, color: "#fff" };
  },
};

export default function GameStream({
  game,
  setSelectedPlayer,
  selectedPlayer,
  isFruit,
  homeCoach,
  awayCoach,
}) {
  const {
    previewGraphic,
    animateGraphic,
    graphicInPreview,
    animateOffGraphic,
    updateGraphic,
    clearPVW,
  } = useContext(GraphicsContext);
  const {
    homeKit,
    awayKit,
    homeScore: localHomeScore,
    awayScore: localAwayScore,
    setHomeScore: setLocalHomeScore,
    setAwayScore: setLocalAwayScore,
    setScoringMode,
    scoringMode,
    localPeriod,
    setLocalPeriod,
    extraTimeToggle,
    setExtraTimeToggle,
    clockHide,
    setClockHide,
  } = useContext(UIContext);
  const { homeScore, awayScore, period, auto_clock } = useContext(ClockContext);
  const { engines, selectedEngine, setSelectedEngine, triggerAnimation } =
    useContext(ControlContext);
  const [selectedGraphic, setSelectedGraphic] = useState();
  const [view, setView] = useState(0);
  const [barview, setbarView] = useState(0);
  const [mode] = useLocalStorage("hyper-netball-gfx-mode", "viz");
  const [commentators, setCommentators] = useLocalStorage(
    "netball-commentators",
    ""
  );
  const [liveFrom, setLiveFrom] = useLocalStorage("netball-live-from", "");
  const [guest1, setGuest1] = useLocalStorage("netball-guest-1", "");
  const [guest2, setGuest2] = useLocalStorage("netball-guest-2", "");
  const [guest3, setGuest3] = useLocalStorage("netball-guest-3", "");
  const [guest4, setGuest4] = useLocalStorage("netball-guest-4", "");
  const [guest5, setGuest5] = useLocalStorage("netball-guest-5", "");
  const [analysis1, setAnalysis1] = useLocalStorage("netball-analysis-1", "");
  const [analysis2, setAnalysis2] = useLocalStorage("netball-analysis-2", "");
  const [analysis3, setAnalysis3] = useLocalStorage("netball-analysis-3", "");
  const [analysis4, setAnalysis4] = useLocalStorage("netball-analysis-4", "");
  const [SmartBar, setSmartBar] = useLocalStorage("SmartBar", "");
  const [GameState, setGameState] = useLocalStorage("Gamestate", "");
  const [SuperShot, setSuperShot] = useLocalStorage("SuperShot", "0");
  const [formationtoggle, setFormationtoggle] = useLocalStorage("formationtoggle", "");
  const [manualQuarter, setManualQuarter] = useLocalStorage("manualQuarter", "1st Quarter");
  const QuarterDropDownOptions = [{value: "1st Quarter", label: "1st Quarter"}, 
    {value: "End of 1st Quarter", label: "End of 1st Quarter"},
    {value: "2nd Quarter", label: "2nd Quarter"}, 
    {value: "End of 2nd Quarter", label: "End of 2nd Quarter"},
    {value: "Half-Time", label: "Half-Time"},
    {value: "3rd Quarter", label: "3rd Quarter"}, 
    {value: "End of 3rd Quarter", label: "End of 3rd Quarter"},
    {value: "4th Quarter", label: "4th Quarter"}, 
    {value: "Extra Time", label: "Extra Time"}, 
    {value: "Final Score", label: "Final Score"},
    {value: "", label: "CLEARED"}];
  let BarState =
    GameState === "Pres"
    ? "gen"
    : "team";
  
  useEffect(() => {
    updateGraphic("CLOCK", {
      homeScore:
        localHomeScore?.game === game?._id ? localHomeScore?.score : "0",
      awayScore:
        localAwayScore?.game === game?._id ? localAwayScore?.score : "0",
      mode: scoringMode?.game === game?._id ? scoringMode?.mode : "stadium",
      period: localPeriod?.game === game?._id ? localPeriod?.period : "Q1",
      extraTimeToggle: extraTimeToggle?.game === game?._id ? extraTimeToggle?.etmode : "false",
      clockHide: clockHide?.game === game?._id ? clockHide?.clockvis : "show",
    });
  }, [localHomeScore, localAwayScore, game, scoringMode, localPeriod, extraTimeToggle, clockHide]);
  return (
    <Main>
      {game && game.home_team && game.away_team && (
        <Content>
          <ActionPanel>
            <Lineups>
              {game && (
                <LineupStream
                  manager={homeCoach}
                  isFruit={isFruit}
                  game={game}
                  team={game.home_team}
                  lineup={
                    game.lineup?.home?.length > 0
                      ? game.lineup?.home
                      : new Array(11)?.fill(1)?.map((_, index) => {
                          return { order: index + 1 };
                        })
                  }
                  player_stats={game.home_player_stats || []}
                  selectedPlayer={selectedPlayer}
                  selectPlayer={(player) => {
                    if (player) {
                      setSelectedPlayer({ ...player, team: game.home_team });
                    } else {
                      setSelectedPlayer();
                    }
                  }}
                />
              )}
              <Column
                style={{
                  width: "15%",
                  marginTop: "37px",
                  alignItems: "center",
                }}
              >
                {mode === "hyper" && engines?.length > 1 && (
                  <>
                    Select Engine
                    <SelectContainer
                      styles={DropdownStyles}
                      minWidth={200}
                      value={{
                        value: selectedEngine,
                        label: engines?.find((e) => e.key === selectedEngine)
                          ?.name,
                      }}
                      options={engines.map((item, index) => {
                        return {
                          value: item.key,
                          label: item.name,
                        };
                      })}
                      onChange={(e) => {
                        setSelectedEngine(e.value);
                      }}
                      placeholder="Round"
                    />
                  </>
                )}
                Game State
                <Row>
                  <GraphicButton
                    onClick={() =>{
                      setGameState("Pres")
                    }}
                    green = {GameState === "Pres"}
                    >
                      Pres Coverage
                  </GraphicButton>
                                    <GraphicButton
                    onClick={() =>{
                      setGameState("Match")
                    }}
                    green = {GameState === "Match"}
                    >
                      Match Coverage
                  </GraphicButton>
                </Row>

              </Column>

              {game && (
                <LineupStream
                  manager={awayCoach}
                  isFruit={isFruit}
                  game={game}
                  team={game.away_team}
                  lineup={
                    game.lineup?.away?.length > 0
                      ? game.lineup?.away
                      : new Array(11)?.fill(1)?.map((_, index) => {
                          return { order: index + 1 };
                        })
                  }
                  player_stats={game.away_player_stats || []}
                  selectedPlayer={selectedPlayer}
                  selectPlayer={(player) => {
                    if (player) {
                      setSelectedPlayer({ ...player, team: game.away_team });
                    } else {
                      setSelectedPlayer();
                    }
                  }}
                />
              )}
            </Lineups>
          </ActionPanel>
          <Tabs>
            <Tab
              selected={view === 0}
              onClick={() => {
                setView(0);
              }}
            >
              Game
            </Tab>
            <Tab
              selected={view === 1}
              onClick={() => {
                setView(1);
              }}
            >
              Full frames
            </Tab>
            <Tab
              selected={view === 2}
              onClick={() => {
                setView(2);
              }}
            >
              Guests
            </Tab>
            <Tab
              selected={view === 3}
              onClick={() => {
                setView(3);
              }}
            >
              Manual Clock
            </Tab>
            <Tab
              selected={view === 4}
              onClick={() => {
                setView(4);
              }}
            >
              Smart Bar
            </Tab>
            <Tab
              selected={view === 5}
              onClick={() => {
                setView(5);
              }}
            >
              Analysis Tags
            </Tab>
          </Tabs>
          {view === 0 && (
            <GraphicsPanel>
              <Column>
                <GraphicButton
                  onClick={() => {
                    setSelectedGraphic("HomeFormation");
                    previewGraphic("SOF_Formation", {
                      game: game,
                      team: game.home_team,
                      manager: homeCoach,
                      kit: homeKit,
                      
                    });
                  }}
                >
                  SOF Home Formation
                </GraphicButton>
                {selectedGraphic === "HomeFormation" && (
                  <>
                    <GraphicButton
                      green
                      onClick={() => {
                        animateGraphic("SOF_Formation");
                      }}
                    >
                      In
                    </GraphicButton>
                    <GraphicButton
                      red
                      onClick={() => {
                        setSelectedGraphic();
                        animateOffGraphic("SOF_Formation");
                      }}
                    >
                      Out
                    </GraphicButton>
                  </>
                )}
              </Column>
              <Column>
                <GraphicButton
                  onClick={() => {
                    setSelectedGraphic("AwayFormation");
                    previewGraphic("SOF_Formation", {
                      game: game,
                      team: game.away_team,
                      manager: awayCoach,
                      kit: awayKit,
                    });
                  }}
                >
                  SOF Away Formation
                </GraphicButton>
                {selectedGraphic === "AwayFormation" && (
                  <>
                    <GraphicButton
                      green
                      onClick={() => {
                        animateGraphic("SOF_Formation");
                      }}
                    >
                      In
                    </GraphicButton>
                    <GraphicButton
                      red
                      onClick={() => {
                        setSelectedGraphic();
                        animateOffGraphic("SOF_Formation");
                      }}
                    >
                      Out
                    </GraphicButton>
                  </>
                )}
              </Column>
              <Column>
                <GraphicButton
                  onClick={() => {
                    setSelectedGraphic("MatchIdent_ComingUp");
                    previewGraphic("MatchIdent_ComingUp", {
                      game: game,
                      commentators,
                      liveFrom,
                    });
                  }}
                >
                  Coming Up Match Ident 
                </GraphicButton>
                {selectedGraphic === "MatchIdent_ComingUp" && (
                  <>
                    <GraphicButton
                      green
                      onClick={() => {
                        animateGraphic("MatchIdent_ComingUp");
                      }}
                    >
                      In
                    </GraphicButton>
                    <GraphicButton
                      red
                      onClick={() => {
                        setSelectedGraphic();
                        animateOffGraphic("MatchIdent_ComingUp");
                      }}
                    >
                      Out
                    </GraphicButton>
                  </>
                )}
              </Column>
              <Column>
                <GraphicButton
                  onClick={() => {
                    setSelectedGraphic("MatchIdent");
                    previewGraphic("MatchIdent", {
                      game: game,
                      commentators,
                      liveFrom,
                      homeKit: homeKit,
                      awayKit: awayKit,
                    });
                  }}
                >
                  Match Ident
                </GraphicButton>
                {selectedGraphic === "MatchIdent" && (
                  <>
                    <GraphicButton
                      green
                      onClick={() => {
                        animateGraphic("MatchIdent");
                      }}
                    >
                      In
                    </GraphicButton>
                    <GraphicButton
                      red
                      onClick={() => {
                        setSelectedGraphic();
                        animateOffGraphic("MatchIdent");
                      }}
                    >
                      Out
                    </GraphicButton>
                  </>
                )}
              </Column>
              <Column>
                <GraphicButton
                  onClick={() => {
                    setSelectedGraphic("Score");

                    previewGraphic("ScoreStream", {
                      game: game,
                      subtitle: manualQuarter ? manualQuarter : "",
                      homeScore,
                      awayScore,
                      homeKit: homeKit,
                      awayKit: awayKit,
                    });
                  }}
                >
                  Match Score
                </GraphicButton>
                <div style={{alignItems: "center", display: "flex", justifyContent: "center"}}>
                <SelectContainer
                      styles={DropdownStyles}
                      value={{
                        value: manualQuarter,
                        label: manualQuarter,
                      }}
                      options={QuarterDropDownOptions.map((item, index) => {
                        return {
                          value: item.value,
                          label: item.label,
                        };
                      })}
                      onChange={(e) => {
                        setManualQuarter(e.value);
                      }}
                      placeholder="Round"
                    />
                    </div>
                {selectedGraphic === "Score" && (
                  <>
                    <GraphicButton
                      green
                      onClick={() => {
                        animateGraphic("ScoreStream");
                      }}
                    >
                      In
                    </GraphicButton>
                    <GraphicButton
                      red
                      onClick={() => {
                        setSelectedGraphic();
                        animateOffGraphic("ScoreStream");
                      }}
                    >
                      Out
                    </GraphicButton>
                  </>
                )}
              </Column>
              {selectedPlayer && (
                <Column>
                  {" "}
                  <GraphicButton
                    onClick={() => {
                      setSelectedGraphic("Name");
                      previewGraphic("Name", {
                        game: game,
                        player: selectedPlayer,
                        subtext: selectedPlayer?.team?.name,
                        team: selectedPlayer?.team,
                        baroption: BarState, 
                        homeKit: homeKit,
                        awayKit: awayKit,
                      });
                    }}
                  >
                    {selectedPlayer?.first_name} {selectedPlayer?.last_name}
                  </GraphicButton>
                  {selectedGraphic === "Name" && (
                    <>
                      <GraphicButton
                        green
                        onClick={() => {
                          animateGraphic("Name");
                        }}
                      >
                        In
                      </GraphicButton>
                      <GraphicButton
                        red
                        onClick={() => {
                          setSelectedGraphic();
                          animateOffGraphic("Name");
                        }}
                      >
                        Out
                      </GraphicButton>
                    </>
                  )}
                </Column>
              )}
              {!selectedPlayer && (
                <Column>
                  <HiddenButton></HiddenButton>
                </Column>
              )}
              <Column>
                <ClockStream
                  game={game}
                  previewGraphic={previewGraphic}
                  animateGraphic={animateGraphic}
                  animateOffGraphic={animateOffGraphic}
                  updateGraphic={updateGraphic}
                  triggerAnimation={triggerAnimation}
                  setGameState={setGameState}
                  GameState={GameState}
                />
              </Column>

              <Column
              style={{alignItems: "flex-end",
              }}>
                <Row>
                  Commentators
                  <Input
                  style={{width: "300px",}}
                    value={commentators}
                    onChange={(e) => {
                      setCommentators(e.currentTarget.value);
                    }}
                  />
                </Row>
                <Row>
                  Live from
                  <Input
                  style={{width: "300px",}}
                    value={liveFrom}
                    onChange={(e) => {
                      setLiveFrom(e.currentTarget.value);
                    }}
                  />
                </Row>
                <Row>
                  Home Team
                  <GraphicButton
                    green
                    onClick={() => {
                      animateGraphic("Timeout", {
                        game,
                        team: game?.home_team,
                        kit: homeKit,
                      });
                    }}
                  >
                    Timeout In
                  </GraphicButton>
                  <GraphicButton
                    red
                    onClick={() => {
                      animateOffGraphic("Timeout");
                    }}
                  >
                    Timeout Out
                  </GraphicButton>
                </Row>
                <Row>
                  Away Team
                  <GraphicButton
                    green
                    onClick={() => {
                      animateGraphic("Timeout", {
                        game,
                        team: game?.away_team,
                        kit: awayKit,
                      });
                    }}
                  >
                    Timeout In
                  </GraphicButton>
                  <GraphicButton
                    red
                    onClick={() => {
                      animateOffGraphic("Timeout");
                    }}
                  >
                    Timeout Out
                  </GraphicButton>
                </Row>
                <Row>
                  Amex SuperShot
                  <Input
                  style={{width: "75px",}}
                  placeholder="INPUT NUMBER"
                  value={SuperShot}
                    onChange={(e) => {
                      setSuperShot(e.currentTarget.value);
                    }}
                  />
                  <GraphicButton
                    green
                    onClick={() => {
                      animateGraphic("AmexPromo", {
                        superShot: SuperShot,
                      });
                    }}
                  >
                    AMEX In
                  </GraphicButton>
                  <GraphicButton
                    red
                    onClick={() => {
                      animateOffGraphic("AmexPromo");
                    }}
                  >
                    AMEX Out
                  </GraphicButton>
                </Row>
                                <Row>
                  Amex No Counter
                  <GraphicButton
                    green
                    onClick={() => {
                      animateGraphic("AmexPromoAlt", {
                        superShot: SuperShot,
                      });
                    }}
                  >
                    AMEX In
                  </GraphicButton>
                  <GraphicButton
                    red
                    onClick={() => {
                      animateOffGraphic("AmexPromoAlt");
                    }}
                  >
                    AMEX Out
                  </GraphicButton>
                </Row>
              </Column>
            </GraphicsPanel>
          )}
          {view === 1 && (
            <GraphicsPanel>
              <Column>
                <TitleButton>
                  Formation Content
                </TitleButton>
                  <GraphicButton
                    onClick={() =>{
                      setFormationtoggle("kit")
                    }}
                    green = {formationtoggle === "kit"}
                    >
                      Kit Image
                  </GraphicButton>
                  <GraphicButton
                    onClick={() =>{
                      setFormationtoggle("text")
                    }}
                    green = {formationtoggle === "text"}
                    >
                      Text Only
                  </GraphicButton>
              </Column>
               <Column>
                <GraphicButton
                  onClick={() => {
                    setSelectedGraphic("HomeFormation");
                    previewGraphic("Formation", {
                      game: game,
                      team: game.home_team,
                      manager: homeCoach,
                      kit: homeKit,
                      formationtoggle: formationtoggle,
                      
                    });
                  }}
                >
                  Home Formation
                </GraphicButton>
                {selectedGraphic === "HomeFormation" && (
                  <>
                    <GraphicButton
                      green
                      onClick={() => {
                        animateGraphic("Formation");
                      }}
                    >
                      In
                    </GraphicButton>
                    <GraphicButton
                      red
                      onClick={() => {
                        setSelectedGraphic();
                        animateOffGraphic("Formation");
                      }}
                    >
                      Out
                    </GraphicButton>
                  </>
                )}
              </Column>
              <Column>
                <GraphicButton
                  onClick={() => {
                    setSelectedGraphic("AwayFormation");
                    previewGraphic("Formation", {
                      game: game,
                      team: game.away_team,
                      manager: awayCoach,
                      kit: awayKit,
                      formationtoggle: formationtoggle,
                    });
                  }}
                >
                  Away Formation
                </GraphicButton>
                {selectedGraphic === "AwayFormation" && (
                  <>
                    <GraphicButton
                      green
                      onClick={() => {
                        animateGraphic("Formation");
                      }}
                    >
                      In
                    </GraphicButton>
                    <GraphicButton
                      red
                      onClick={() => {
                        setSelectedGraphic();
                        animateOffGraphic("Formation");
                      }}
                    >
                      Out
                    </GraphicButton>
                  </>
                )}
              </Column>
              <Column>
                <GraphicButton
                  onClick={() => {
                    setSelectedGraphic("OpenerSlate");
                    previewGraphic("OpenerSlate", {
                      game: game,
                      team: game.home_team,
                      liveFrom,
                    });
                  }}
                >
                  Match Ident
                </GraphicButton>
                {selectedGraphic === "OpenerSlate" && (
                  <>
                    <GraphicButton
                      green
                      onClick={() => {
                        animateGraphic("OpenerSlate");
                      }}
                    >
                      In
                    </GraphicButton>
                    <GraphicButton
                      red
                      onClick={() => {
                        setSelectedGraphic();
                        animateOffGraphic("OpenerSlate");
                      }}
                    >
                      Out
                    </GraphicButton>
                  </>
                )}
              </Column>
              <Column>
                <GraphicButton
                  onClick={() => {
                    setSelectedGraphic("OffTheCourt");
                    previewGraphic("Page", {
                      page: 10014,
                      caption: "OFF THE COURT\n COMING NEXT",
                    });
                  }}
                >
                  Off the court
                </GraphicButton>
                {selectedGraphic === "OffTheCourt" && (
                  <>
                    <GraphicButton
                      green
                      onClick={() => {
                        animateGraphic("Page");
                      }}
                    >
                      In
                    </GraphicButton>
                    <GraphicButton
                      red
                      onClick={() => {
                        setSelectedGraphic();
                        animateOffGraphic("Page");
                      }}
                    >
                      Out
                    </GraphicButton>
                  </>
                )}
              </Column>
              <Column>
                <GraphicButton
                  onClick={() => {
                    setSelectedGraphic("CoverageStarts");
                    previewGraphic("Page", {
                      page: 10015,
                      caption: "COVERAGE STARTS\n SHORTLY",
                    });
                  }}
                >
                  Coverage starts shortly
                </GraphicButton>
                {selectedGraphic === "CoverageStarts" && (
                  <>
                    <GraphicButton
                      green
                      onClick={() => {
                        animateGraphic("Page");
                      }}
                    >
                      In
                    </GraphicButton>
                    <GraphicButton
                      red
                      onClick={() => {
                        setSelectedGraphic();
                        animateOffGraphic("Page");
                      }}
                    >
                      Out
                    </GraphicButton>
                  </>
                )}
              </Column>
              <Column>
                <GraphicButton
                  onClick={() => {
                    setSelectedGraphic("CoverageFinished");
                    previewGraphic("Page", {
                      page: 10016,
                      caption: "COVERAGE HAS\n FINISHED",
                    });
                  }}
                >
                  Coverage has finished
                </GraphicButton>
                {selectedGraphic === "CoverageFinished" && (
                  <>
                    <GraphicButton
                      green
                      onClick={() => {
                        animateGraphic("Page");
                      }}
                    >
                      In
                    </GraphicButton>
                    <GraphicButton
                      red
                      onClick={() => {
                        setSelectedGraphic();
                        animateOffGraphic("Page");
                      }}
                    >
                      Out
                    </GraphicButton>
                  </>
                )}
              </Column>
              <Column>
                <GraphicButton
                  onClick={() => {
                    setSelectedGraphic("TechincalSlate");
                    previewGraphic("TechincalSlate", {
                      game: game,
                      team: game.home_team,
                      caption: "TECHNICAL\nDIFFICULTIES",
                    });
                  }}
                >
                  Technical Slate
                </GraphicButton>
                {selectedGraphic === "TechincalSlate" && (
                  <>
                    <GraphicButton
                      green
                      onClick={() => {
                        animateGraphic("TechincalSlate");
                      }}
                    >
                      In
                    </GraphicButton>
                    <GraphicButton
                      red
                      onClick={() => {
                        setSelectedGraphic();
                        animateOffGraphic("TechincalSlate");
                      }}
                    >
                      Out
                    </GraphicButton>
                  </>
                )}
              </Column>
            </GraphicsPanel>
          )}
          {view === 2 && (
            <GraphicsPanel>
              <GuestGFX
                game={game}
                guest={guest1}
                setGuest={setGuest1}
                previewGraphic={previewGraphic}
                selectedGraphic={selectedGraphic}
                animateGraphic={animateGraphic}
                animateOffGraphic={animateOffGraphic}
                setSelectedGraphic={setSelectedGraphic}
                label="Guest 1"
                label2="Voice Of Guest 1"
              />
              <GuestGFX
                game={game}
                guest={guest2}
                setGuest={setGuest2}
                previewGraphic={previewGraphic}
                selectedGraphic={selectedGraphic}
                animateGraphic={animateGraphic}
                animateOffGraphic={animateOffGraphic}
                setSelectedGraphic={setSelectedGraphic}
                label="Guest 2"
                label2="Voice Of Guest 2"
              />
              <GuestGFX
                game={game}
                guest={guest3}
                setGuest={setGuest3}
                previewGraphic={previewGraphic}
                selectedGraphic={selectedGraphic}
                animateGraphic={animateGraphic}
                animateOffGraphic={animateOffGraphic}
                setSelectedGraphic={setSelectedGraphic}
                label="Guest 3"
                label2="Voice Of Guest 3"
              />
              <GuestGFX
                game={game}
                guest={guest4}
                setGuest={setGuest4}
                previewGraphic={previewGraphic}
                selectedGraphic={selectedGraphic}
                animateGraphic={animateGraphic}
                animateOffGraphic={animateOffGraphic}
                setSelectedGraphic={setSelectedGraphic}
                label="Guest 4"
                label2="Voice Of Guest 4"
              />
              <GuestGFX
                game={game}
                guest={guest5}
                setGuest={setGuest5}
                previewGraphic={previewGraphic}
                selectedGraphic={selectedGraphic}
                animateGraphic={animateGraphic}
                animateOffGraphic={animateOffGraphic}
                setSelectedGraphic={setSelectedGraphic}
                label="Guest 5"
                label2="Voice Of Guest 5"
              />
            </GraphicsPanel>
          )}
          {view === 3 && (
            <GraphicsPanel>
              <Column>
                <GraphicButton
                  onClick={() => {
                    setSelectedGraphic("Score");

                    previewGraphic("ScoreStream", {
                      game: game,
                      subtitle: manualQuarter ? manualQuarter : "",
                      homeScore:
                        localHomeScore?.game === game?._id
                          ? localHomeScore?.score
                          : "",
                      awayScore:
                        localAwayScore?.game === game?._id
                          ? localAwayScore?.score
                          : "",
                      homeKit: homeKit,
                      awayKit: awayKit,
                    });
                  }}
                >
                  Match Score
                </GraphicButton>
                <div style={{alignItems: "center", display: "flex", justifyContent: "center"}}>
                <SelectContainer
                      styles={DropdownStyles}
                      value={{
                        value: manualQuarter,
                        label: manualQuarter,
                      }}
                      options={QuarterDropDownOptions.map((item, index) => {
                        return {
                          value: item.value,
                          label: item.label,
                        };
                      })}
                      onChange={(e) => {
                        setManualQuarter(e.value);
                      }}
                      placeholder="Round"
                    />
                    </div>
                {selectedGraphic === "Score" && (
                  <>
                    <GraphicButton
                      green
                      onClick={() => {
                        animateGraphic("ScoreStream");
                      }}
                    >
                      In
                    </GraphicButton>
                    <GraphicButton
                      red
                      onClick={() => {
                        setSelectedGraphic();
                        animateOffGraphic("ScoreStream");
                      }}
                    >
                      Out
                    </GraphicButton>
                  </>
                )}
              </Column>
              {selectedPlayer && (
                <Column>
                  {" "}
                  <GraphicButton
                    onClick={() => {
                      setSelectedGraphic("Name");
                      previewGraphic("Name", {
                        game: game,
                        player: selectedPlayer,
                        subtext: selectedPlayer?.team?.name,
                        team: selectedPlayer?.team,
                      });
                    }}
                  >
                    {selectedPlayer?.first_name} {selectedPlayer?.last_name}
                  </GraphicButton>
                  {selectedGraphic === "Name" && (
                    <>
                      <GraphicButton
                        green
                        onClick={() => {
                          animateGraphic("Name");
                        }}
                      >
                        In
                      </GraphicButton>
                      <GraphicButton
                        red
                        onClick={() => {
                          setSelectedGraphic();
                          animateOffGraphic("Name");
                        }}
                      >
                        Out
                      </GraphicButton>
                    </>
                  )}
                </Column>
              )}
              {!selectedPlayer && (
                <Column>
                  <HiddenButton></HiddenButton>
                </Column>
              )}
              <Column>
                Scores
                <Row>
                  <Row
                    style={{
                      border:
                        "1px solid " +
                        game.home_team?.variables?.[homeKit + "_kit_bg"],
                    }}
                  >
                    <Column>
                      <Row
                        style={{ justifyContent: "center", fontSize: "20px" }}
                      >
                        {game?.home_team?.code}
                      </Row>
                      <Row
                        style={{ justifyContent: "center", fontSize: "20px" }}
                      >
                        {localHomeScore?.game === game?._id
                          ? localHomeScore?.score
                          : 0}
                      </Row>
                      <Row>
                        <GraphicButton
                          onClick={() => {
                            let score =
                              localHomeScore?.game === game?._id
                                ? localHomeScore?.score
                                : 0;

                            setLocalHomeScore({
                              game: game?._id,
                              score: Math.max(0, parseInt(score) - 1),
                            });
                          }}
                        >
                          -1
                        </GraphicButton>

                        <GraphicButton
                          onClick={() => {
                            let score =
                              localHomeScore?.game === game?._id
                                ? localHomeScore?.score
                                : 0;

                            setLocalHomeScore({
                              game: game?._id,
                              score: parseInt(score) + 1,
                            });
                          }}
                        >
                          +1
                        </GraphicButton>
                        <GraphicButton
                          onClick={() => {
                            let score =
                              localHomeScore?.game === game?._id
                                ? localHomeScore?.score
                                : 0;

                            setLocalHomeScore({
                              game: game?._id,
                              score: parseInt(score) + 2,
                            });
                            let SuperShotUpdate = parseInt(SuperShot) + 1;
                            setSuperShot(SuperShotUpdate)
                          }}
                        >
                          +2
                        </GraphicButton>
                      </Row>
                    </Column>
                  </Row>
                  <Row
                    style={{
                      margin: "1em",
                      border:
                        "1px solid " +
                        game.away_team?.variables?.[awayKit + "_kit_bg"],
                    }}
                  >
                    <Column>
                      <Row
                        style={{ justifyContent: "center", fontSize: "20px" }}
                      >
                        {game?.away_team?.code}
                      </Row>
                      <Row
                        style={{ justifyContent: "center", fontSize: "20px" }}
                      >
                        {localAwayScore?.game === game?._id
                          ? localAwayScore?.score
                          : 0}
                      </Row>
                      <Row>
                        <GraphicButton
                          onClick={() => {
                            let score =
                              localAwayScore?.game === game?._id
                                ? localAwayScore?.score
                                : 0;

                            setLocalAwayScore({
                              game: game?._id,
                              score: Math.max(0, parseInt(score) - 1),
                            });
                          }}
                        >
                          -1
                        </GraphicButton>

                        <GraphicButton
                          onClick={() => {
                            let score =
                              localAwayScore?.game === game?._id
                                ? localAwayScore?.score
                                : 0;

                            setLocalAwayScore({
                              game: game?._id,
                              score: parseInt(score) + 1,
                            });
                          }}
                        >
                          +1
                        </GraphicButton>
                        <GraphicButton
                          onClick={() => {
                            let score =
                              localAwayScore?.game === game?._id
                                ? localAwayScore?.score
                                : 0;

                            setLocalAwayScore({
                              game: game?._id,
                              score: parseInt(score) + 2,
                            });
                            let SuperShotUpdate = parseInt(SuperShot) + 1;
                            setSuperShot(SuperShotUpdate)
                          }}
                        >
                          +2
                        </GraphicButton>
                      </Row>
                    </Column>
                  </Row>
                </Row>
                <Row>
                  <GraphicButton
                    green={
                      scoringMode?.game === game?._id
                        ? scoringMode?.mode === "stadium"
                        : true
                    }
                    onClick={() => {
                      setScoringMode({ game: game?._id, mode: "stadium" });
                    }}
                  >
                    STADIUM MODE
                  </GraphicButton>
                  <GraphicButton
                    green={
                      scoringMode?.game === game?._id
                        ? scoringMode?.mode === "manual"
                        : false
                    }
                    onClick={() => {
                      setScoringMode({ game: game?._id, mode: "manual" });
                      setExtraTimeToggle({ game: game?._id, etmode: "false" });
                    }}
                  >
                    MANUAL MODE
                  </GraphicButton>
                  <GraphicButton
                    green={
                      clockHide?.game === game?._id
                        ? clockHide?.clockvis === "hide"
                        : false
                    }
                    onClick={() => {
                      setClockHide({ game: game?._id, clockvis: "hide" });
                    }}
                  >
                    HIDE CLOCK
                  </GraphicButton>
                  <GraphicButton
                    green={
                      clockHide?.game === game?._id
                        ? clockHide?.clockvis === "show"
                        : false
                    }
                    onClick={() => {
                      setClockHide({ game: game?._id, clockvis: "show" });
                    }}
                  >
                    SHOW CLOCK
                  </GraphicButton>
                </Row>
                <Row>
                  <PeriodButton
                    onClick={() => {
                      setLocalPeriod({ game: game?._id, period: "Q1" });
                      setExtraTimeToggle({ game: game?._id, etmode: "false" });
                    }}
                    green={
                      localPeriod?.game === game?._id
                        ? localPeriod?.period === "Q1"
                        : true
                    }
                  >
                    Q1
                  </PeriodButton>
                  <PeriodButton
                    onClick={() => {
                      setLocalPeriod({ game: game?._id, period: "Q2" });
                      setExtraTimeToggle({ game: game?._id, etmode: "false" });
                    }}
                    green={
                      localPeriod?.game === game?._id
                        ? localPeriod?.period === "Q2"
                        : false
                    }
                  >
                    Q2
                  </PeriodButton>
                  <PeriodButton
                    onClick={() => {
                      setLocalPeriod({ game: game?._id, period: "Q3" });
                      setExtraTimeToggle({ game: game?._id, etmode: "false" });
                    }}
                    green={
                      localPeriod?.game === game?._id
                        ? localPeriod?.period === "Q3"
                        : false
                    }
                  >
                    Q3
                  </PeriodButton>
                  <PeriodButton
                    onClick={() => {
                      setLocalPeriod({ game: game?._id, period: "Q4" });
                      setExtraTimeToggle({ game: game?._id, etmode: "false" });
                    }}
                    green={
                      localPeriod?.game === game?._id
                        ? localPeriod?.period === "Q4"
                        : false
                    }
                  >
                    Q4
                  </PeriodButton>
                  <PeriodButton
                    onClick={() => {
                      setLocalPeriod({ game: game?._id, period: "ET1" });
                      if (scoringMode?.game === game?._id && scoringMode?.mode === "stadium") {
                        setExtraTimeToggle({ game: game?._id, etmode: "true" });
                      }
                    }}
                    green={
                      localPeriod?.game === game?._id
                        ? localPeriod?.period === "ET1"
                        : false
                    }
                  >
                    ET1
                  </PeriodButton>
                  <PeriodButton
                    onClick={() => {
                      setLocalPeriod({ game: game?._id, period: "ET2" });
                      if (scoringMode?.game === game?._id && scoringMode?.mode === "stadium") {
                        setExtraTimeToggle({ game: game?._id, etmode: "true" });
                      }
                    }}
                    green={
                      localPeriod?.game === game?._id
                        ? localPeriod?.period === "ET2"
                        : false
                    }
                  >
                    ET2
                  </PeriodButton>
                  <PeriodButton
                    onClick={() => {
                      setLocalPeriod({ game: game?._id, period: "EET" });
                      if (scoringMode?.game === game?._id && scoringMode?.mode === "stadium") {
                        setExtraTimeToggle({ game: game?._id, etmode: "true" });
                      }
                    }}
                    green={
                      localPeriod?.game === game?._id
                        ? localPeriod?.period === "EET"
                        : false
                    }
                  >
                    EET
                  </PeriodButton>
                </Row>
              </Column>
              <Column>
                <ClockStream
                  game={game}
                  previewGraphic={previewGraphic}
                  animateGraphic={animateGraphic}
                  animateOffGraphic={animateOffGraphic}
                  updateGraphic={updateGraphic}
                  triggerAnimation={triggerAnimation}
                  setGameState={setGameState}
                  GameState={GameState}
                />
              </Column>
            </GraphicsPanel>
          )}
          {view === 4 && (
            <GraphicsPanel>
            <SmartBarMain
                game={game}
                SmartBar={SmartBar}
                setSmartBar={setSmartBar}
                previewGraphic={previewGraphic}
                selectedGraphic={selectedGraphic}
                animateGraphic={animateGraphic}
                animateOffGraphic={animateOffGraphic}
                selectedPlayer={selectedPlayer}
                setbarView={setbarView}
                barview={barview}
                homeKit={homeKit}
                awayKit={awayKit}
                setSelectedGraphic={setSelectedGraphic}>
            </SmartBarMain>
            </GraphicsPanel>
              )}
            {view === 5 && (
            <GraphicsPanel>
              <AnalysisGFX
                game={game}
                analysis={analysis1}
                setAnalysis={setAnalysis1}
                previewGraphic={previewGraphic}
                selectedGraphic={selectedGraphic}
                animateGraphic={animateGraphic}
                animateOffGraphic={animateOffGraphic}
                setSelectedGraphic={setSelectedGraphic}
                label="Anaylsis Tag 1"
              />
              <AnalysisGFX
                game={game}
                analysis={analysis2}
                setAnalysis={setAnalysis2}
                previewGraphic={previewGraphic}
                selectedGraphic={selectedGraphic}
                animateGraphic={animateGraphic}
                animateOffGraphic={animateOffGraphic}
                setSelectedGraphic={setSelectedGraphic}
                label="Anaylsis Tag 2"
              />
              <AnalysisGFX
                game={game}
                analysis={analysis3}
                setAnalysis={setAnalysis3}
                previewGraphic={previewGraphic}
                selectedGraphic={selectedGraphic}
                animateGraphic={animateGraphic}
                animateOffGraphic={animateOffGraphic}
                setSelectedGraphic={setSelectedGraphic}
                label="Anaylsis Tag 3"
              />
              <AnalysisGFX
                game={game}
                analysis={analysis4}
                setAnalysis={setAnalysis4}
                previewGraphic={previewGraphic}
                selectedGraphic={selectedGraphic}
                animateGraphic={animateGraphic}
                animateOffGraphic={animateOffGraphic}
                setSelectedGraphic={setSelectedGraphic}
                label="Anaylsis Tag 4"
              />
            </GraphicsPanel>
          )}
        </Content>
      )}
    </Main>
  );
}

function GuestGFX({
  game,
  guest,
  setGuest,
  previewGraphic,
  selectedGraphic,
  animateGraphic,
  animateOffGraphic,
  setSelectedGraphic,
  label,
  label2,
}) {
  return (
    <Column style={{ marginRight: "30px" }}>
      Guest Name
      <Input
        value={guest?.name}
        onChange={(e) => {
          let new_guest_1 = { ...guest };
          new_guest_1.name = e.currentTarget.value;
          setGuest(new_guest_1);
        }}
      />
      Guest Subline
      <Input
        value={guest?.subline}
        onChange={(e) => {
          let new_guest_1 = { ...guest };
          new_guest_1.subline = e.currentTarget.value;
          setGuest(new_guest_1);
        }}
      />
      <Row
      style={{alignItems: "flex-start"}}>
      <Column>
      <GraphicButton
        onClick={() => {
          setSelectedGraphic(label);
          previewGraphic("Guest", {
            game: game,
            name: guest?.name,
            subline: guest?.subline,
          });
        }}
      >
        {label}
      </GraphicButton>
      {selectedGraphic === label && (
        <>
          <GraphicButton
            green
            onClick={() => {
              animateGraphic("Guest");
            }}
          >
            In
          </GraphicButton>
          <GraphicButton
            red
            onClick={() => {
              setSelectedGraphic();
              animateOffGraphic("Guest");
            }}
          >
            Out
          </GraphicButton>
        </>
      )}
      </Column>
      <Column>
        <GraphicButton
        onClick={() => {
          setSelectedGraphic(label2);
          previewGraphic("VoiceOf", {
            game: game,
            name: guest?.name,
            subline: "Voice Of",
          });
        }}
      >
        {label2}
      </GraphicButton>
      {selectedGraphic === label2 && (
        <>
          <GraphicButton
            green
            onClick={() => {
              animateGraphic("VoiceOf");
            }}
          >
            In
          </GraphicButton>
          <GraphicButton
            red
            onClick={() => {
              setSelectedGraphic();
              animateOffGraphic("VoiceOf");
            }}
          >
            Out
          </GraphicButton>
        </>
      )}
      </Column>
      </Row>
    </Column>
  );
}

function AnalysisGFX({
  game,
  analysis,
  setAnalysis,
  previewGraphic,
  selectedGraphic,
  animateGraphic,
  animateOffGraphic,
  setSelectedGraphic,
  label,
}) {
  return (
    <Column style={{ marginRight: "30px" }}>
      Analysis Tag
      <Input
        value={analysis?.name}
        onChange={(e) => {
          let new_analysis_1 = { ...analysis };
          new_analysis_1.name = e.currentTarget.value;
          setAnalysis(new_analysis_1);
        }}
      />
      Analysis Subline
      <Input
        value={analysis?.subline}
        onChange={(e) => {
          let new_analysis_1 = { ...analysis };
          new_analysis_1.subline = e.currentTarget.value;
          setAnalysis(new_analysis_1);
        }}
      />
      <GraphicButton
        onClick={() => {
          setSelectedGraphic(label);
          previewGraphic("Analysis", {
            game: game,
            name: analysis?.name,
            subline: analysis?.subline,
          });
        }}
      >
        {label}
      </GraphicButton>
      {selectedGraphic === label && (
        <>
          <GraphicButton
            green
            onClick={() => {
              animateGraphic("Analysis");
            }}
          >
            In
          </GraphicButton>
          <GraphicButton
            red
            onClick={() => {
              setSelectedGraphic();
              animateOffGraphic("Analysis");
            }}
          >
            Out
          </GraphicButton>
        </>
      )}
    </Column>
  );
}
